import { render, staticRenderFns } from "./plan-item-5.vue?vue&type=template&id=bfcf731e&scoped=true&"
import script from "./plan-item-5.vue?vue&type=script&lang=js&"
export * from "./plan-item-5.vue?vue&type=script&lang=js&"
import style0 from "./plan-item-5.vue?vue&type=style&index=0&id=bfcf731e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcf731e",
  null
  
)

export default component.exports